<template>
  <div class="contact">
    <logo />
    <div class="boxwrap">
      <div v-if="waiting || forceWait" class="loading">
        <loading />
      </div>
      <div v-else-if="success">
        <h1>Application has been submitted</h1>
      </div>
      <div v-else-if="error">
        <h1>An error has occurred</h1>
      </div>
      <div v-else class="rounded detailBox shadow">
        <h2 class="titleLine inverted">Contact details for client</h2>
        <br />
        <h2>Contact name</h2>
        <input
          class="input"
          placeholder="Firstname Lastname"
          v-model.trim="name"
        />
        <h2>Phone number</h2>
        <input
          class="input"
          placeholder="include any region code"
          inputmode="numeric"
          pattern="[0-9]*"
          v-model.trim="number"
        />
        <h2>Email address</h2>
        <input
          class="input"
          placeholder="example@email.com"
          v-model.trim="email"
        />
      </div>
    </div>
    <div class="buttonBar">
      <div v-if="success" @click="$router.push('/')" class="button Enabled">
        <p>Home</p>
      </div>
      <div v-else @click="$router.go(-1)" class="button Enabled">
        <p>Back</p>
      </div>
      <div
        v-if="!success"
        @click="next"
        :class="contactValid ? 'button Enabled' : 'button Disabled'"
      >
        <p>Submit</p>
      </div>
    </div>
  </div>
</template>

<script>
import loading from "@/components/loading";
export default {
  components: {
    loading
  },
  methods: {
    back: function() {
      if (this.error || this.success) {
        this.$router.push("/");
      } else {
        this.$router.go(-1);
      }
    },
    next: function() {
      this.waiting = true;
      this.forceWait = true;
      let yearsParsed = 0;
      let phoenix = this.$store.state.formData.yearsTrading === "Phoenix";
      if (this.$store.state.formData.yearsTrading === "1 - 3 years") {
        yearsParsed = 2;
      }
      if (this.$store.state.formData.yearsTrading === "3+ years") {
        yearsParsed = 3;
      }
      if (this.$store.state.testMode === true) {
        alert("This app is running in test mode and will not be followed up");
      }
      setTimeout(() => {
        this.forceWait = false;
      }, 2200);

      if (process.env.VUE_APP_MODE !== "production") {
        this.$gtag.event("stagingDecide");
      } else {
        this.$gtag.event("decide");
      }
      this.axios
        .post("/api/decide", {
          introducerId: this.$store.state.introducerId,
          quotationOnly: this.$store.state.testMode === true,
          name: this.$store.state.formData.businessName,
          companyNumber: this.$store.state.formData.companyReg,
          companyType: this.$store.state.formData.companyType,
          sector: this.$store.state.formData.sector,
          turnover: this.$store.state.formData.turnover,
          homeowners: this.$store.state.formData.homeOwners,
          yearsTrading: yearsParsed,
          startup: this.$store.state.formData.yearsTrading === "Start-up",
          phoenix: phoenix,
          expectedCustomers: this.$store.state.formData.customers,
          creditControl: this.$store.state.formData.creditControl,
          contactName: this.name,
          contactNumber: this.number,
          contactEmail: this.email
        })
        .then(() => {
          this.success = true;
          this.waiting = false;
        })
        .catch(err => {
          this.error = err;
          this.waiting = false;
        });
    },
    validateEmail: function(mail) {
      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,13})+$/.test(mail)) {
        return true;
      }
      return false;
    }
  },
  data: function() {
    return {
      name: null,
      number: null,
      email: null,
      waiting: false,
      error: null,
      success: false,
      forceWait: false
    };
  },
  computed: {
    contactValid: function() {
      let ret =
        this.name &&
        this.number &&
        this.email &&
        this.name.length > 3 &&
        this.number.length > 5 &&
        this.validateEmail(this.email);
      return ret;
    }
  }
};
</script>

<style lang="scss" scoped>
.loading {
  width: 40vh;
}
.input {
  border-radius: 7px;
  border: solid var(--base-colour, #535450) 2px;
  margin-top: -1em;
}
.row {
  display: grid;
  grid-template-columns: 1fr 1fr;

  width: 100%;
  text-align: right;
  .response {
    text-align: center;
  }
}
.table {
}

.buttonBar {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  margin-bottom: 50px;
}

.contact {
  width: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
}
.boxwrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 2;
  width: 100%;
}
.titleLine {
  margin: -2em;
  padding: 1em;
  margin-bottom: -1.5em;
}
</style>